module.exports = __webpack_public_path__ + "img/2019homepark-2.17aea684.jpeg";